// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"3553f376","673":"9830a131","903":"cfefac3d"}[chunkId] + ".chunk.css";
};